import { useSelector } from 'react-redux';
const useReviewPanel = () => {
    const {reviewPanelList} = useSelector((state) => state.reviewPanel);
    const columns = [{ field: 'panelName', headerName: 'Panel Name', width: 600 }];
    return { rows:reviewPanelList, columns };
};

export default useReviewPanel;
